import React from 'react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const RedisIcon = (props) => {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <g transform="translate(3 4)" fill="none" fillRule="evenodd">
        <path
          d="M25 15.4c-1.4.7-8.6 3.7-10.1 4.5-1.5.8-2.4.8-3.6.2-1.2-.6-8.9-3.7-10.2-4.3-.7-.3-1-.6-1.1-.9v2.6c0 .3.4.5 1 .9 1.4.7 9 3.7 10.2 4.3 1.2.6 2.1.6 3.6-.2s8.7-3.8 10.1-4.5c.7-.4 1-.7 1-.9v-2.6c.1.2-.2.5-.9.9z"
          fill="#912626"
        />
        <path
          d="M14.9 18.2c-1.5.8-2.4.8-3.6.2-1.2-.6-8.9-3.7-10.2-4.3-.7.3-1 .5-1 .8 0 .3.4.5 1.1.9 1.4.7 9 3.7 10.2 4.3 1.2.6 2.1.6 3.6-.2s8.7-3.8 10.1-4.5c.7-.4 1-.6 1-.9 0-.3-.4-.5-1-.7-1.6.7-8.7 3.6-10.2 4.4z"
          fill="#C6302B"
        />
        <path
          d="M26 12.8v-2.6c0 .3-.3.5-1 .9-1.4.7-8.6 3.7-10.1 4.5-1.5.8-2.4.8-3.6.2-1.2-.6-8.9-3.7-10.2-4.3-.7-.3-1-.6-1.1-.9v2.6c0 .3.4.5 1 .9 1.4.7 9 3.7 10.2 4.3 1.2.6 2.1.6 3.6-.2s8.7-3.7 10.1-4.5c.8-.3 1.1-.6 1.1-.9z"
          fill="#912626"
        />
        <path
          d="M1.1 11.5c1.4.7 9 3.7 10.2 4.3 1.2.6 2.1.6 3.6-.2s8.7-3.8 10.1-4.5c.7-.4 1-.6 1-.9 0-.3-.4-.5-1-.7 0 0-.1 0-.2-.1-1.8.9-8.4 3.6-9.9 4.4-1.5.8-2.4.8-3.6.2-1.2-.6-8.4-3.5-10.1-4.3-.1 0-.2.1-.2.1-.7.3-1 .5-1 .8 0 .3.4.6 1.1.9z"
          fill="#C6302B"
        />
        <path
          d="M11.3 14c1.2.6 2.1.6 3.6-.2s8.1-3.5 9.9-4.4c.1 0 .1-.1.2-.1.7-.4 1-.7 1-.9V5.8c0 .3-.3.5-1 .9-1.4.7-8.6 3.7-10.1 4.5-1.5.8-2.4.8-3.6.2-1.2-.6-8.9-3.7-10.2-4.3-.7-.3-1-.6-1.1-.9v2.6c0 .3.4.5 1 .9 0 0 .1 0 .2.1 1.7.7 8.9 3.7 10.1 4.2z"
          fill="#912626"
        />
        <path
          d="M1.1 7.1c1.4.7 9 3.7 10.2 4.3 1.2.6 2.1.6 3.6-.2S23.6 7.4 25 6.7c.7-.4 1-.6 1-.9 0-.3-.4-.5-1-.7-1.4-.5-8.5-3.3-9.9-3.8-1.4-.5-1.9-.5-3.5.1-1.6.5-9.2 3.5-10.6 4-.7.3-1 .5-1 .8 0 .3.4.6 1.1.9zm3.2-1c0-.7 1.4-1.2 3.2-1.2 1.8 0 3.2.6 3.2 1.2 0 .7-1.4 1.2-3.2 1.2-1.8 0-3.2-.5-3.2-1.2zm4.8 2.2l6-.9-1.8 2.6-4.2-1.7zm9.7-3.8v2.8l-.4.1L14.9 6l3.9-1.5zm0 2.8V4.5l3.5 1.4-3.5 1.4zM13.2 3l1.7-.6-.5 1.1 1.7.6-2.2.2-.5 1.2-.8-1.3-2.5-.2 1.9-.7-.6-1.1 1.8.8z"
          fill="#C6302B"
          fillRule="nonzero"
        />
        <path
          fill="#FFF"
          d="M12 3.3l-1.9.7 2.5.3.8 1.3.5-1.2 2.3-.2-1.8-.7.5-1.1-1.7.6-1.8-.7z"
        />
        <ellipse fill="#FFF" cx="7.5" cy="6.1" rx="3.2" ry="1.2" />
        <path fill="#FFF" d="M13.3 10l1.8-2.6-6 .9z" />
        <path fill="#621B1C" d="M18.8 7.3l3.6-1.4-3.6-1.4z" />
        <path fill="#9A2928" d="M18.8 7.3V4.5L14.9 6l3.5 1.4z" />
      </g>
    </SVG>
  );
};

export default RedisIcon;
